/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const OfferExchangeRates = zod
  .union([
    zod.object({
      status: zod.literal("NOT_USED"),
    }),
    zod.object({
      status: zod.literal("AVAILABLE"),
      provider: zod.literal("ECB"),
      publicationDate: zod.iso.date(),
    }),
    zod.object({
      status: zod.literal("UNAVAILABLE"),
      provider: zod.literal("ECB"),
      reason: zod.literal("MISSING_PUBLICATION"),
      requiredPublicationDate: zod.iso.date(),
    }),
    zod.object({
      status: zod.literal("UNAVAILABLE"),
      provider: zod.literal("ECB"),
      reason: zod.literal("STALE_PUBLICATION"),
      requiredPublicationDate: zod.iso.date(),
      publicationDate: zod.iso.date(),
    }),
  ])
  .describe(
    "Whole-evaluation public provenance, never raw quotes or private pair associations. Issued evidence describes its captured book, not current freshness. NOT_USED is not a content certificate.",
  );

export type OfferExchangeRates = zod.input<typeof OfferExchangeRates>;
export type OfferExchangeRatesOutput = zod.output<typeof OfferExchangeRates>;
